import React, { Component } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import Searcher from "../searcher/Searcher";
import { setEmptyClient } from "../../actions/ClientAction";
import { showPermission, hidePermission } from "../../actions/PermissionAction";
import { showComment, hideComment } from "../../actions/CommentAction";
import {
  getGroupByClientIdUserId,
  getGroupByClient
} from "../../actions/GroupAction";
import { setWidth } from "../../actions/AppAction";
import { deleteToken } from "../../api/AuthApi";
import "./navbar.css";

export class PrivateNavBarClients extends Component {
  constructor(props) {
    super(props);

    this.containerRef = React.createRef();

    this.state = {
      showNavBarItems: false,
      showSearchIcons: false,
      showSearchIconsMobile: false,
      showUserMenu: false,
      defaultAvatar: "/images/icons/user-icon.svg",
      defaultColor: "#2E97CF",
      defaultLogo: ""
    };
  }

  componentDidMount() {
    const { avatar, newColor, newClientLogo } = this.props;

    this.props.hidePermission();

    if (avatar) {
      this.setState({
        defaultAvatar: avatar
      });
    }
    if (newColor) {
      this.setState({
        defaultColor: newColor
      });
    }

    if (newClientLogo) {
      this.setState({
        defaultLogo: newClientLogo
      });
    }

    window.addEventListener("resize", this.handleSetCurrentWidht);
    setTimeout(() => {
      this.handleSetCurrentWidht();
    }, 1000);
  }

  handleSetCurrentWidht = () => {
    if (this.containerRef && this.containerRef.current) {
      this.props.setWidth(this.containerRef.current.offsetWidth);
    }
  };

  handleUserLogOut = () => {
    deleteToken()
      .then(res => this.props.history.push("/logout"))
      .catch(err => {
        console.log(err);
        this.props.history.push("/logout");
      });
  };

  handleShowActivityLog = () => {
    this.props.history.push("/activity-log-init");
  };

  handleShowClientSelector = () => {
    this.props.history.push("/client-selector");
  };

  handleBackHome = () => {
    const { showSearchIcons } = this.state;
    const { workclient } = this.props;
    if (workclient) this.props.history.push("/home");

    if (showSearchIcons) {
      this.handleHideSearchIcons();
      return;
    }
  };

  //MUESTRA LOS ICONOS DE NAVBAR CUANDO ESTA EN MOBILE
  handleShowSearchIcons = () => {
    const { showSearchIcons } = this.state;
    this.setState({
      showSearchIcons: !showSearchIcons,
      showNavBarItems: false
    });
  };

  handleOnClickInputSearch = () => {
    const { showSearchIcons } = this.state;
    const { width } = this.props;
    if (width >= 970) {
      this.setState({
        showSearchIcons: !showSearchIcons
      });
    }
  };

  handleHideSearchIcons = () => {
    this.setState({
      showSearchIcons: false
    });
  };

  handleShowUserMenu = () => {
    const { showUserMenu } = this.state;
    this.setState({ showUserMenu: !showUserMenu });
  };

  render() {
    const hash = "#";
    const { showUserMenu, defaultAvatar, defaultColor } = this.state;
    const { user, intl, showSearchLog } = this.props;
    const userFirstName = user && user.name ? user.name.split(" ")[0] : "";

    return (
      <React.Fragment>
        <div
          className="nav-menu bb-nav-header"
          style={{ backgroundColor: defaultColor }}
        >
          <div className="nav-container">
            <div className="nav-bb-bars">
              <svg
                width={29}
                height={21}
                viewBox="0 0 29 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.75 1.75C0.75 1.05964 1.30965 0.5 2 0.5H27C27.6904 0.5 28.25 1.05964 28.25 1.75C28.25 2.44036 27.6904 3 27 3H2C1.30965 3 0.75 2.44036 0.75 1.75Z"
                  fill="white"
                />
                <path
                  d="M0.75 10.5C0.75 9.80963 1.30965 9.25 2 9.25H27C27.6904 9.25 28.25 9.80963 28.25 10.5C28.25 11.1904 27.6904 11.75 27 11.75H2C1.30965 11.75 0.75 11.1904 0.75 10.5Z"
                  fill="white"
                />
                <path
                  d="M2 18C1.30965 18 0.75 18.5596 0.75 19.25C0.75 19.9404 1.30965 20.5 2 20.5H27C27.6904 20.5 28.25 19.9404 28.25 19.25C28.25 18.5596 27.6904 18 27 18H2Z"
                  fill="white"
                />
              </svg>
            </div>
            <div
              className="nav-search-bar"
              style={{ backgroundColor: defaultColor }}
            >
              <div className="nav-content-left">
                <div className="nav-brand-content">
                  <img
                    className="nav-bunkey-logo-desktop"
                    src="/images/logo-animado.gif"
                    alt="Bunkey"
                    onClick={this.handleBackHome}
                  />
                </div>
                <img
                  className="nav-bunkey-logo-mobile"
                  alt="Bunkey"
                  src="https://dam.bunkey.tv/images/bunkey-logo-mobile.svg"
                />
                {showSearchLog !== false && (
                  <Searcher
                    handleShowSearchIcons={this.handleShowSearchIcons}
                    handleOnClickInputSearch={this.handleOnClickInputSearch}
                    handleHideSearchIcons={this.handleHideSearchIcons}
                    showSearchIcons={false}
                    showSearchNew={true}
                    defaultAvatar={defaultAvatar}
                    isClient={true}
                  />
                )}
              </div>
            </div>
            <div
              className="tour-user user-bar"
              style={{ borderBottom: "rgb(46, 151, 207)", cursor: "pointer" }}
            >
              <div className={showUserMenu ? "user user-dropdown" : "user"}>
                <div className="href-test" onClick={this.handleShowUserMenu}>
                  <span>{userFirstName}</span>
                  <img className="user-img" src={defaultAvatar} alt="user" />
                </div>
                <div className="user-options">
                  {showUserMenu && (
                    <div onMouseLeave={this.handleHideUserMenu}>
                      <ul className="user-close-session">
                        <li onClick={this.handleShowActivityLog}>
                          <a href={hash}>
                            <span>
                              {intl.formatMessage({ id: "activity_log" })}
                            </span>
                          </a>
                        </li>
                      </ul>
                      <ul className="user-close-session">
                        <li onClick={this.handleShowClientSelector}>
                          <a href={hash}>
                            <span>
                              {intl.formatMessage({
                                id: "clients_client_List"
                              })}
                            </span>
                          </a>
                        </li>
                      </ul>
                      <ul className="user-close-session">
                        <li onClick={this.handleUserLogOut}>
                          <a href={hash}>
                            <span>{intl.formatMessage({ id: "logout" })}</span>
                            <svg
                              width={18}
                              height={15}
                              viewBox="0 0 18 15"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M5.65898 13.8253C6.8233 14.569 8.20664 15 9.69064 15C13.8328 15 17.1906 11.6421 17.1906 7.5C17.1906 3.35786 13.8328 0 9.69064 0C7.91555 0 6.28448 0.616679 5 1.64749L5.80325 2.29008C6.88744 1.4798 8.23301 1 9.69064 1C13.2805 1 16.1906 3.91015 16.1906 7.5C16.1906 11.0899 13.2805 14 9.69064 14C8.52758 14 7.43586 13.6945 6.49134 13.1594L5.65898 13.8253Z"
                                fill="#526193"
                              />
                              <path
                                d="M0.646446 7.64645C0.451184 7.84171 0.451184 8.15829 0.646446 8.35355L3.82843 11.5355C4.02369 11.7308 4.34027 11.7308 4.53553 11.5355C4.7308 11.3403 4.7308 11.0237 4.53553 10.8284L1.70711 8L4.53553 5.17157C4.7308 4.97631 4.7308 4.65973 4.53553 4.46447C4.34027 4.2692 4.02369 4.2692 3.82843 4.46447L0.646446 7.64645ZM1 8.5L12.5 8.5L12.5 7.5L1 7.5L1 8.5Z"
                                fill="#526193"
                              />
                            </svg>
                          </a>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    permissionItem: state.permission.item,
    width: state.app.width,
    user: state.authUser.user,
    clientselect: state.client.data,
    downloadProgress: state.client.downloadProgress,
    breadcrumb: state.client.breadcrumb,
    isUploading: state.client.isUploading,
    workclient: state.client.workclient,
    avatar: state.authUser.user.avatar,
    error: state.authUser.user.error,
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF",
    newClientLogo:
      state.client.data && state.client.data.acountSetting
        ? state.client.data.acountSetting.logo
        : null,
    logoError: state.client.logoError,
    searchData: state.searcher.data,
    matrix: state.group.matrix,
    toBeConfirmed: state.notifications.toBeConfirmed,
    userRequests: state.notifications.userRequests,
    pid: state.notifications.pid,
    showMessage: state.notifications.showMessage
  };
};

const mapDispatchToProps = {
  setEmptyClient,
  setWidth,
  showPermission,
  hidePermission,
  getGroupByClientIdUserId,
  getGroupByClient,
  showComment,
  hideComment
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(PrivateNavBarClients))
);
